import { NavLink, Outlet } from "react-router-dom";
import { Box, styled } from "@mui/material";

const TabsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.divider,
  borderRadius: 999,
  padding: 4,
  width: "fit-content",
  gap: 2,
  margin: theme.spacing(2, 2, 0),
}));

const TabLink = styled(NavLink)(({ theme }) => ({
  padding: "5px 20px",
  borderRadius: 999,
  fontSize: "0.875rem",
  fontWeight: 500,
  textDecoration: "none",
  color: theme.palette.text.secondary,
  transition: "all 150ms ease",
  whiteSpace: "nowrap",

  "&:hover": {
    color: theme.palette.text.primary,
  },

  "&.active": {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
}));

const tabs = [
  { name: "Collections", path: "collections" },
  { name: "Payouts", path: "payouts" },
];

const TransactionOutlet = () => {
  return (
    <Box>
      <TabsWrapper>
        {tabs.map((tab) => (
          <TabLink key={tab.path} to={`/transactions/${tab.path}`}>
            {tab.name}
          </TabLink>
        ))}
      </TabsWrapper>

      <Outlet />
    </Box>
  );
};

export default TransactionOutlet;
